export enum TvhLanguage {
  NL = 'nl',
  FR = 'fr',
  EN = 'en',
}
